import { atomWithStorage } from 'jotai/utils'

export const authState = atomWithStorage<{ token: string | undefined }>(
  'auth',
  { token: undefined }
)
